export const GET_BILL_LIST = 'GET_BILL_LIST';
